// extracted by mini-css-extract-plugin
module.exports = {"container":"k9J_7","wrapper":"_3XvuA","photo-story-wrapper":"_18usB","wrapper-slider":"_2AbI7"};